<template>
  <div class="timeline-mismatch flex-center pointer">
    <i class="error-circle-icon" :id="target"></i>
    <popover :target="target" triggers="hover" custom-class="parent-goal-popover" placement="top">
      <h3 class="text-normal-1">
        Review goal timelines
      </h3>
      <p class="text-medium-1 mb-0">
        Your child goal and parent goal timelines are not aligned, you can still create this goal,
      </p>
    </popover>
  </div>
</template>

<script>
import Popover from '@/components/Popover'

/**
 * This shows a warning icon, hover of which triggers a popover containing information about timeline mismatch amongst goal's child and parent goals
 */
export default {
  name: 'TimelineMismatchCallout',
  props: [],
  components: {
    Popover
  },
  data() {
    return {
      target: 'timeline-warning-' + this.uuid
    }
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.timeline-mismatch {
  padding: 3px;
  border-radius: 50%;
  background-color: $warningSecondary;
}
</style>
